import { render, staticRenderFns } from "./add-item.vue?vue&type=template&id=79a066d7"
import script from "./add-item.vue?vue&type=script&lang=js"
export * from "./add-item.vue?vue&type=script&lang=js"
import style0 from "./add-item.vue?vue&type=style&index=0&id=79a066d7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports